// state
import axios from "axios";
import commonservice from "../../shared/common.service";

const defaultState = () => ({
  entity: {
    id: null,
    name: null,
    image: null
  }
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
  loadContactus({}, { pagination, search }) {
    return new Promise((resolve, reject) => {
      var param = {
        descending:
          pagination.sortDesc.length > 0 ? pagination.sortDesc[0] : false,
        page: pagination.page,
        rowsPerPage: pagination.itemsPerPage,
        sortBy: pagination.sortBy.length > 0 ? pagination.sortBy[0] : "name",
        search: search
      };
      axios
        .get("/contactus?" + commonservice.convertToQueryString(param))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setContactus({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/contactus/" + id)
        .then(response => {
          commit("SET_CONTACTUS", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveContactus({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.entity.id) {
        axios
          .patch("/contactus", state.entity)
          .then(
            response => {
              commit("RESET");
              resolve(response);
            },
            error => {
              reject(error);
            }
          )
          .catch(error => {
            reject(error);
          });
      } else {
        axios
          .post("/contactus", state.entity)
          .then(
            response => {
              commit("RESET");
              resolve(response);
            },
            error => {
              reject(error);
            }
          )
          .catch(error => {
            reject(error);
          });
      }
    });
  },
  deleteContactus({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/contactus/" + id)
        .then(response => {
          commit("RESET");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  RESET(state) {
    Object.assign(state, defaultState());
  },
  SET_CONTACTUS_DATA(state, data) {
    if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
      state[data.key][data.index][data.property] = data.value;
    } else if (
      Object.prototype.toString.call(state[data.key]) === "[object Object]"
    ) {
      state[data.key][data.property] = data.value;
    } else state.entity[data.key] = data.value;
  },
  SET_CONTACTUS(state, data) {
    state.entity.id = data.id;
    state.entity.name = data.name;
    state.entity.image = data.image;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
